import PropTypes from 'prop-types';
import React from 'react';

require("./feed-provider.scss");

export default function FeedIcon({feed}) {
  if (feed == "ATR") {
    return (
      <div className="feed-provider-icon-ssr feed-provider-icon">
        <img src={`/img/feed-providers/ssr.svg`}/>
      </div>
    );
} else if (feed == "RUK") {
    return (
      <div className="feed-provider-icon-rtv feed-provider-icon">
        <a href="https://www.racingtv.com/" target="_blank">
            <img src={`/img/feed-providers/rtv.svg`}/>
        </a>
      </div>
    );
}
  return null;
}

FeedIcon.propTypes = {
  feed: PropTypes.oneOf(["ATR", "RUK"])
};



// WEBPACK FOOTER //
// ./modules/Common/components/png/FeedIcon.js